import { Link } from "react-router-dom";
import { Reveal } from "../components/Reveal";
import { useT } from "../lib/LanguageContext";
import { CATEGORY_ORDER } from "../lib/serviceCategories";

const Offres = () => {
  const { t } = useT();

  return (
    <main data-testid="page-offres" className="bg-white">
      <section className="pt-40 pb-16 px-6 bg-[#FFFBEA]">
        <div className="max-w-7xl mx-auto text-center">
          <Reveal>
            <h1 className="font-serif text-5xl md:text-7xl font-bold text-[#1A1528]">
              {t("offres.title")}
            </h1>
            <p data-testid="offres-subtitle" className="mt-6 text-lg text-[#4A4558] font-light max-w-3xl mx-auto">
              {t("offres.subtitle")}
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pt-16 md:pt-20 pb-24 md:pb-32 px-6">
        <Reveal>
          <p
            data-testid="offres-custom-note"
            className="max-w-2xl mx-auto text-center font-serif italic text-[#6B5CE7] text-base md:text-lg leading-relaxed mb-14 md:mb-20"
          >
            {t("offres.customNote")}
          </p>
        </Reveal>
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
          {CATEGORY_ORDER.map((c, i) => {
            const info = t(`servicesCatalog.categories.${c.slug}`);
            return (
              <Reveal key={c.slug} delay={i * 0.08}>
                <div
                  data-testid={`category-${c.slug}`}
                  className="h-full bg-[#FFFBEA] rounded-3xl px-10 md:px-14 py-12 md:py-16 border border-[#F5E6A3]/60 hover:shadow-xl hover:-translate-y-1 transition-all duration-500 flex flex-col"
                >
                  <span className="text-xs tracking-[0.3em] text-[#6B5CE7] font-medium mb-4">{c.num}</span>
                  <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A1528] uppercase tracking-wide mb-5">
                    {info.label}
                  </h2>
                  <p className="text-[#4A4558] font-light text-base md:text-lg leading-relaxed flex-1 mb-8">
                    {info.desc}
                  </p>
                  <div>
                    <Link to={`/offres/${c.slug}`} data-testid={`category-cta-${c.slug}`} className="btn-violet text-sm">
                      {t("offres.moreInfo")}
                    </Link>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>
    </main>
  );
};

export default Offres;
